module.exports = __webpack_public_path__ + "static/img/dl-pro-img.b7e1e1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dali/dl-pro-img.png
// module id = z1dE
// module chunks = 19